export enum Mc2Permissions {
  create = "CREATE",
  update = "UPDATE",
  updateState = "UPDATE_STATE",
  delete = "DELETE",
}

type WithPermissions = {
  permissions?: string[] | null;
};

export const hasMc2Permission = <T extends WithPermissions>(
  record: T,
  action: Mc2Permissions,
): boolean => {
  const { permissions } = record;
  if (!permissions) return true;
  return permissions.includes(action);
};
